import { applyMiddleware, createStore } from 'redux';

import { IS_DEV } from '../utils/constants';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';

import refreshMiddleware from './refreshMiddleware';
import rootReducer from './rootReducer';
import thunk from 'redux-thunk';
// import toastMiddleware from './toastMiddleware';

const configureStore = () => {
  const middlewares = applyMiddleware(
    ...[
      thunk,
      refreshMiddleware,
      promiseMiddleware,
      // toastMiddleware,
      IS_DEV &&
        createLogger({
          collapsed: (_a: any, _b: any, logEntry: any) => !logEntry.error
        })
    ].filter(Boolean)
  );

  const store = createStore(
    rootReducer,
    undefined,
    IS_DEV ? composeWithDevTools(middlewares) : middlewares
  );

  return store;
};

export default configureStore;
